var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDmfTagLine(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 304.6,
    height: 164.42,
    viewBox: "0 0 304.6 164.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4597",
    "data-name": "Rectangle 4597",
    width: 304.6,
    height: 164.42,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "dmf_tagLine",
    transform: "translate(152.3 82.21)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "DMF_v_TagLine",
    "data-name": "DMF?v_TagLine",
    transform: "translate(-152.3 -82.21)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16878",
    "data-name": "Path 16878",
    d: "M100.5,91,63.4,128.1h-.2L6,70.9a.2.2,0,0,1,0-.2l6.9-6.8H13l38.5,38.5h.3l2.7-2.7a.2.2,0,0,0,0-.3L13.2,57.9a.3.3,0,0,0-.5,0L.1,70.5a.3.3,0,0,0,0,.5l63,63a.3.3,0,0,0,.5,0l42.8-42.8a.3.3,0,0,0,0-.5L66.6,50.9a.6.6,0,0,1,0-.8C78.9,35.5,75.3,12,55.9,2.5c-7-3.4-18.7-3.3-25.8.2-20.1,10-23,35.1-8.6,49.4l50.2,50.2H72l2.7-2.7a.2.2,0,0,0,0-.3L24,48.6a25.2,25.2,0,0,1-5.7-27.3C26.1,2.2,49-1,61.8,11.8A26.4,26.4,0,0,1,63.6,47a.6.6,0,0,1-.9,0L43.4,27.7a.3.3,0,0,0-.5,0L31.7,38.9a.2.2,0,0,0,0,.3l2.7,2.7h.3L43,33.6h.2l57.2,57.2a.2.2,0,0,1,0,.2",
    fill: "#00a7ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16879",
    "data-name": "Path 16879",
    d: "M149.3,23.4a16.7,16.7,0,0,1-4.5,12q-4.5,4.7-12.5,4.7h-15V37.6h4.4V9.2h-4.4V6.6h14.9q8.1,0,12.6,4.8a16.8,16.8,0,0,1,4.5,12m-3.1,0a14.7,14.7,0,0,0-3.6-10.2q-3.6-4-10.4-4h-7.5V37.6h7.5q6.8,0,10.4-3.9a14.6,14.6,0,0,0,3.6-10.3",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16880",
    "data-name": "Path 16880",
    d: "M184.6,40.1H173.1V37.5h5l-2.7-7.3H160.2l-2.9,7.3h5.3v2.6H151.2V37.5h3.1L165.7,9.2h-5.5V6.6h9l12,30.9h3.4ZM174.5,27.9,168.1,11h-.3l-6.7,16.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16881",
    "data-name": "Path 16881",
    d: "M221.1,9.2h-4.3V40.1h-2L194.9,12.4h-.2V37.5h5.5v2.6H187.9V37.5h3.9V9.2h-4.4V6.6h6.7L213.7,34h.2V9.2h-5.1V6.6h12.3Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16882",
    "data-name": "Path 16882",
    d: "M248.8,31a8.4,8.4,0,0,1-3.4,7.2,13.7,13.7,0,0,1-8.3,2.5,23.7,23.7,0,0,1-6-.7,14.3,14.3,0,0,1-4.3-1.8l.6-6.1,2.4.3-.2,4.2a11.9,11.9,0,0,0,3.5,1.2,22,22,0,0,0,3.9.3,11.3,11.3,0,0,0,6.1-1.6,5.638,5.638,0,0,0,2.6-5.2,5.758,5.758,0,0,0-2.8-5.3,31.1,31.1,0,0,0-6-2l-4.6-1.3a9,9,0,0,1-3.8-2.5,7.2,7.2,0,0,1-1.5-5,8,8,0,0,1,3-6.8,11.7,11.7,0,0,1,7.3-2.3,22.5,22.5,0,0,1,5.5.7A13.1,13.1,0,0,1,247,8.6l.3,6.5-2.4.3-.6-5.3A11.2,11.2,0,0,0,241,9l-3.3-.3a8.9,8.9,0,0,0-5.5,1.6,5.4,5.4,0,0,0-2.1,4.5q0,3.4,2.5,4.5a31,31,0,0,0,5.4,1.9l4.8,1.4a10.2,10.2,0,0,1,4.3,2.7,7.9,7.9,0,0,1,1.8,5.6",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16883",
    "data-name": "Path 16883",
    d: "M284.6,40.1H273.2V37.5h4.1l-9.6-13.2h-5.9V37.5h4.1v2.6H254.4V37.5h4.4V9.2h-4.4V6.6H266V9.2h-4.2V21.8h5.8l9.3-12.6h-4.2V6.5h11.2V9.2h-3.8L270,22.7l10.7,14.8h3.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16884",
    "data-name": "Path 16884",
    d: "M158.2,53.6h-4.5V81.9h4.4v2.6H146.6V81.9h4.2V58.3h-.2L138.7,83.1h-1.8L124.8,58.2h-.2V81.9h4.3v2.6H117.4V81.9h4.4V53.6h-4.5V51h7.1l13.4,27.7h.2L151.1,51h7.1Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16885",
    "data-name": "Path 16885",
    d: "M196.3,67.8a18,18,0,0,1-2.1,8.7A16.2,16.2,0,0,1,179.6,85a16,16,0,0,1-8.7-2.3,16.4,16.4,0,0,1-5.8-6.3,18.1,18.1,0,0,1-2.1-8.7,17.9,17.9,0,0,1,2.1-8.7,16.5,16.5,0,0,1,5.9-6.2A16.927,16.927,0,0,1,194.2,59a18.1,18.1,0,0,1,2.1,8.7m-3.1.1a15.2,15.2,0,0,0-3.7-10.4,12.5,12.5,0,0,0-9.9-4.2,12.3,12.3,0,0,0-9.9,4.3,15.3,15.3,0,0,0-3.6,10.3A15.5,15.5,0,0,0,169.7,78a13.6,13.6,0,0,0,19.8.1,15.3,15.3,0,0,0,3.6-10.3",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16886",
    "data-name": "Path 16886",
    d: "M229.8,60.9l-2.7.2-1-7.5h-9.5V81.9h6v2.6H207.7V81.9h5.9V53.6h-9.5L203,61.1l-2.6-.2,1-9.9h27.4Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16887",
    "data-name": "Path 16887",
    d: "M267.3,67.8a18,18,0,0,1-2.1,8.7A16.2,16.2,0,0,1,250.5,85a16,16,0,0,1-8.7-2.3,16.3,16.3,0,0,1-5.8-6.3,18.1,18.1,0,0,1-2.1-8.7A17.9,17.9,0,0,1,236,59a16.5,16.5,0,0,1,5.9-6.2A17.046,17.046,0,0,1,265.2,59a18.1,18.1,0,0,1,2.1,8.7m-3.1.1a15.2,15.2,0,0,0-3.7-10.4,12.5,12.5,0,0,0-9.9-4.2,12.3,12.3,0,0,0-9.9,4.3A15.3,15.3,0,0,0,237,67.7,15.5,15.5,0,0,0,240.7,78a13.6,13.6,0,0,0,19.8.1,15.3,15.3,0,0,0,3.6-10.3",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16888",
    "data-name": "Path 16888",
    d: "M300.9,84.5h-6.2l-7.4-14.4h-7.9V81.9h4.7v2.6h-12V81.9h4.4V53.6h-4.4V51h14.3q6.2,0,8.8,2.8a9.4,9.4,0,0,1,2.5,6.6,9.9,9.9,0,0,1-1.8,5.8,9,9,0,0,1-5.6,3.5L296.7,82H301Zm-6.3-24.1a6.3,6.3,0,0,0-2-5.1q-2-1.7-6.4-1.7h-6.7v14h6.8q4.4,0,6.4-1.9a7.1,7.1,0,0,0,1.9-5.3",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16889",
    "data-name": "Path 16889",
    d: "M143.2,105.4l-4.9.5-1.1-5.6H126.8V111h14.6v4.9H126.8V124h5.7v4.9H117.2V124h3.9V100.3h-3.9v-5h24.9Z",
    fill: "#092540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16890",
    "data-name": "Path 16890",
    d: "M160.8,128.9H147.4V124h3.9V100.3h-3.9v-5h13.4v5H157V124h3.8Z",
    fill: "#092540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16891",
    "data-name": "Path 16891",
    d: "M201.3,100.3h-3.9v28.6l-3.3.1-18.6-23.3h-.2V124h4.9v4.9h-14V124h3.7V100.3h-4.2v-5h8.4l17.7,22.3h.2V100.3h-4.9v-5h14.2Z",
    fill: "#092540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16892",
    "data-name": "Path 16892",
    d: "M237.4,128.9H224.5V124h3.4l-1.7-4.6H213.7l-1.8,4.6h3.8v4.9H202.9V124H206l10.1-23.8h-4.9V95.3H222L234.1,124h3.3Zm-12.7-13.7-4.4-11.7H220l-4.6,11.7Z",
    fill: "#092540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16893",
    "data-name": "Path 16893",
    d: "M275.6,100.3h-3.9v28.6l-3.3.1-18.6-23.3h-.2V124h4.9v4.9h-14V124h3.7V100.3H240v-5h8.4l17.7,22.3h.2V100.3h-4.9v-5h14.2Z",
    fill: "#092540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16894",
    "data-name": "Path 16894",
    d: "M304.6,119.1a9.1,9.1,0,0,1-3.5,7.7,14.7,14.7,0,0,1-9.2,2.7,26.1,26.1,0,0,1-6.6-.8,12.8,12.8,0,0,1-5-2.4l.9-7.7,4.6.5v4.1a10.7,10.7,0,0,0,3.1,1.1l2.7.2a11.5,11.5,0,0,0,5-1q2-1,2-3.9a4.46,4.46,0,0,0-2.3-4.2,22.5,22.5,0,0,0-5.2-1.6,42.505,42.505,0,0,1-4.8-1.2,8.9,8.9,0,0,1-4-2.6,7.8,7.8,0,0,1-1.6-5.3q0-5.3,3.6-7.6a14.6,14.6,0,0,1,8-2.3,19.7,19.7,0,0,1,6,.9,12.3,12.3,0,0,1,4.6,2.4l.3,7.1-4.6.4-.5-4.3a10.1,10.1,0,0,0-2.9-1.1l-2.8-.3a7.6,7.6,0,0,0-4,1,3.9,3.9,0,0,0,.4,6.6,23.5,23.5,0,0,0,4.5,1.5l4.8,1.2a10.7,10.7,0,0,1,4.7,2.8q2,2,2,6.1",
    fill: "#092540"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16895",
    "data-name": "Path 16895",
    d: "M143.2,105.4l-4.9.5-1.1-5.6H126.8V111h14.6v4.9H126.8V124h5.7v4.9H117.2V124h3.9V100.3h-3.9v-5h24.9Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16896",
    "data-name": "Path 16896",
    d: "M160.8,128.9H147.4V124h3.9V100.3h-3.9v-5h13.4v5H157V124h3.8Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16897",
    "data-name": "Path 16897",
    d: "M201.3,100.3h-3.9v28.6l-3.3.1-18.6-23.3h-.2V124h4.9v4.9h-14V124h3.7V100.3h-4.2v-5h8.4l17.7,22.3h.2V100.3h-4.9v-5h14.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16898",
    "data-name": "Path 16898",
    d: "M237.4,128.9H224.5V124h3.4l-1.7-4.6H213.7l-1.8,4.6h3.8v4.9H202.9V124H206l10.1-23.8h-4.9V95.3H222L234.1,124h3.3Zm-12.7-13.7-4.4-11.7H220l-4.6,11.7Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16899",
    "data-name": "Path 16899",
    d: "M275.6,100.3h-3.9v28.6l-3.3.1-18.6-23.3h-.2V124h4.9v4.9h-14V124h3.7V100.3H240v-5h8.4l17.7,22.3h.2V100.3h-4.9v-5h14.2Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16900",
    "data-name": "Path 16900",
    d: "M304.6,119.1a9.1,9.1,0,0,1-3.5,7.7,14.7,14.7,0,0,1-9.2,2.7,26.1,26.1,0,0,1-6.6-.8,12.8,12.8,0,0,1-5-2.4l.9-7.7,4.6.5v4.1a10.7,10.7,0,0,0,3.1,1.1l2.7.2a11.5,11.5,0,0,0,5-1q2-1,2-3.9a4.46,4.46,0,0,0-2.3-4.2,22.5,22.5,0,0,0-5.2-1.6,42.505,42.505,0,0,1-4.8-1.2,8.9,8.9,0,0,1-4-2.6,7.8,7.8,0,0,1-1.6-5.3q0-5.3,3.6-7.6a14.6,14.6,0,0,1,8-2.3,19.7,19.7,0,0,1,6,.9,12.3,12.3,0,0,1,4.6,2.4l.3,7.1-4.6.4-.5-4.3a10.1,10.1,0,0,0-2.9-1.1l-2.8-.3a7.6,7.6,0,0,0-4,1,3.9,3.9,0,0,0,.4,6.6,23.5,23.5,0,0,0,4.5,1.5l4.8,1.2a10.7,10.7,0,0,1,4.7,2.8q2,2,2,6.1",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16901",
    "data-name": "Path 16901",
    d: "M14.2,164.2H9.3v-1.6h1.5v-9.8H9.3v-1.6h4.9v1.6H12.7v9.8h1.5Z",
    fill: "#abbfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16902",
    "data-name": "Path 16902",
    d: "M32.8,152.8H31.1v9.8h1.5v1.6H27.9v-1.6h1.4v-7.3h-.1l-4.1,8.1h-.9L20,155.2h-.1v7.4h1.5v1.6H16.6v-1.6h1.6v-9.8H16.5v-1.6h3.3l4.9,9.6h.1l4.7-9.6h3.3Z",
    fill: "#abbfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16903",
    "data-name": "Path 16903",
    d: "M45.3,155.3a3.9,3.9,0,0,1-1.3,3.2,4.8,4.8,0,0,1-3.2,1.1H38.4v3.1h2.2v1.6H35v-1.6h1.6v-9.8H35v-1.6h5.7a4.6,4.6,0,0,1,3.5,1.2,4,4,0,0,1,1.1,2.9m-1.9,0a2.5,2.5,0,0,0-.7-1.8,3,3,0,0,0-2.2-.7H38.4V158h2.1q2.8,0,2.8-2.7",
    fill: "#abbfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16904",
    "data-name": "Path 16904",
    d: "M60.3,157.7a6.8,6.8,0,0,1-1.8,4.7,6.2,6.2,0,0,1-4.8,2,6,6,0,0,1-4.8-2,6.9,6.9,0,0,1-1.7-4.7A6.594,6.594,0,0,1,58.5,153a6.8,6.8,0,0,1,1.8,4.7m-2,0a5.5,5.5,0,0,0-1.2-3.7,4.2,4.2,0,0,0-3.3-1.4,4.1,4.1,0,0,0-3.4,1.5,5.5,5.5,0,0,0-1.2,3.6,5.7,5.7,0,0,0,1.2,3.6,4.7,4.7,0,0,0,6.8.1,5.5,5.5,0,0,0,1.2-3.6",
    fill: "#abbfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16905",
    "data-name": "Path 16905",
    d: "M73.8,164.2H71l-2.7-5.3H65.7v3.7h1.6v1.6h-5v-1.6h1.6v-9.8H62.3v-1.6H68a5.1,5.1,0,0,1,3.5,1,3.5,3.5,0,0,1,1.1,2.7,3.6,3.6,0,0,1-2.7,3.6l2.2,4.1h1.6Zm-3-9.2a2,2,0,0,0-.7-1.7,3.9,3.9,0,0,0-2.3-.5h-2v4.6h2a3.3,3.3,0,0,0,2.3-.6,2.3,2.3,0,0,0,.7-1.8",
    fill: "#abbfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16906",
    "data-name": "Path 16906",
    d: "M86.7,155.3l-1.6.1-.4-2.6h-3v9.8H84v1.6H77.7v-1.6h2.2v-9.8h-3l-.4,2.6-1.5-.1.3-4.1h11Z",
    fill: "#abbfc9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4594",
    "data-name": "Rectangle 4594",
    width: 2.3,
    height: 2.48,
    transform: "translate(93.9 161.7)",
    fill: "#abbfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16907",
    "data-name": "Path 16907",
    d: "M113.3,164.2h-9.5v-1.6h1.5v-9.8h-1.5v-1.6h5.4v1.6h-2v9.8h4.5l.4-2.8,1.6.1Z",
    fill: "#abbfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16908",
    "data-name": "Path 16908",
    d: "M125.2,164.2h-9.8v-1.6H117v-9.8h-1.6v-1.6h9.7l.4,3.7-1.6.2-.4-2.3h-4.7v4.1h6v1.5h-6v4.2h4.9l.4-2.2,1.5.1Z",
    fill: "#abbfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16909",
    "data-name": "Path 16909",
    d: "M140.4,164.2h-4.8v-1.6h1.5l-.8-2.2h-5.2l-.9,2.2H132v1.6h-4.7v-1.6h1.2l4.1-9.8h-2v-1.6h3.9l4.7,11.4h1.3Zm-4.6-5.1-2-5.3h-.1l-2.1,5.3Z",
    fill: "#abbfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16910",
    "data-name": "Path 16910",
    d: "M151.1,160.5a3.4,3.4,0,0,1-1.3,2.9,5.5,5.5,0,0,1-3.4,1,9.5,9.5,0,0,1-2.5-.3,5.2,5.2,0,0,1-1.8-.8l.3-2.8h1.5v1.6l1.3.5h1.2a4.2,4.2,0,0,0,2.1-.5,2.1,2.1,0,0,0-.1-3.5l-2.1-.7-1.9-.5a3.4,3.4,0,0,1-1.5-1,2.9,2.9,0,0,1-.6-2,3.2,3.2,0,0,1,1.3-2.8,5.2,5.2,0,0,1,3-.9,8,8,0,0,1,2.3.3,4.8,4.8,0,0,1,1.7.8v2.7H149l-.2-1.8-1.2-.4h-1.1a3.1,3.1,0,0,0-1.8.5,1.6,1.6,0,0,0-.7,1.4,1.5,1.5,0,0,0,.8,1.5l1.9.6,1.9.5a4.1,4.1,0,0,1,1.8,1.1,3.2,3.2,0,0,1,.7,2.3",
    fill: "#abbfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16911",
    "data-name": "Path 16911",
    d: "M158.3,164.2h-4.9v-1.6H155v-9.8h-1.6v-1.6h4.9v1.6h-1.5v9.8h1.5Z",
    fill: "#abbfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16912",
    "data-name": "Path 16912",
    d: "M174.1,152.8h-1.5v11.4h-1.1l-7.4-9.6H164v8h2v1.6h-5.2v-1.6h1.5v-9.8h-1.7v-1.6h3l7.2,9.4h.1v-7.8h-2v-1.6h5.2Z",
    fill: "#abbfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16913",
    "data-name": "Path 16913",
    d: "M188.5,159h-.9v5.3h-1.4l-.2-1.7a4.2,4.2,0,0,1-1.6,1.3,5.2,5.2,0,0,1-2.4.5,5.4,5.4,0,0,1-4.3-1.9,7.5,7.5,0,0,1,.1-9.5,5.9,5.9,0,0,1,4.7-2,8.1,8.1,0,0,1,2.8.4,5.5,5.5,0,0,1,1.9,1.1l.4,2.5-1.5.2-.4-1.8-1.3-.6-1.8-.3a4.2,4.2,0,0,0-3.3,1.4,6.2,6.2,0,0,0-.1,7.4,4,4,0,0,0,3.2,1.4,3.5,3.5,0,0,0,2.6-.9,2.8,2.8,0,0,0,.9-2.1V159H183v-1.6h5.7Z",
    fill: "#abbfc9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4595",
    "data-name": "Rectangle 4595",
    width: 2.3,
    height: 2.48,
    transform: "translate(195.8 161.7)",
    fill: "#abbfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16914",
    "data-name": "Path 16914",
    d: "M217.1,155.3l-1.6.1-.4-2.6h-3v9.8h2.2v1.6h-6.2v-1.6h2.2v-9.8h-3l-.4,2.6-1.6-.1.4-4.1h11Z",
    fill: "#abbfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16915",
    "data-name": "Path 16915",
    d: "M230.3,164.2h-4.8v-1.6H227l-.8-2.2H221l-.9,2.2h1.7v1.6h-4.7v-1.6h1.2l4.1-9.8h-2v-1.6h3.9l4.7,11.4h1.3Zm-4.6-5.1-2-5.3h-.1l-2.1,5.3Z",
    fill: "#abbfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16916",
    "data-name": "Path 16916",
    d: "M243.6,164.2h-4.8v-1.6h1.5l-3.1-3.9-2.8,3.9h1.4v1.6H231v-1.6h1.4l3.9-5.1-3.7-4.7h-1.3v-1.6h4.6v1.6h-1.2l2.7,3.5,2.6-3.5h-1.2v-1.6h4.6v1.6H242l-3.7,4.7,4.1,5.1h1.2Z",
    fill: "#abbfc9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4596",
    "data-name": "Rectangle 4596",
    width: 2.3,
    height: 2.48,
    transform: "translate(250.3 161.7)",
    fill: "#abbfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16917",
    "data-name": "Path 16917",
    d: "M271,163.1a5,5,0,0,1-1.9,1,9.3,9.3,0,0,1-2.6.3,6.1,6.1,0,0,1-4.6-1.9,6.5,6.5,0,0,1-1.8-4.7,7.7,7.7,0,0,1,.7-3.3,6.2,6.2,0,0,1,2.1-2.6,5.9,5.9,0,0,1,3.5-1,7.7,7.7,0,0,1,2.8.4,6.1,6.1,0,0,1,1.9,1.1l.3,2.6-1.5.2-.4-1.9-1.3-.6-1.7-.2a4.1,4.1,0,0,0-3.2,1.4,5.4,5.4,0,0,0-1.2,3.7,5.2,5.2,0,0,0,1.3,3.7,4.5,4.5,0,0,0,3.4,1.3,5.7,5.7,0,0,0,2.7-.6l.3-1.9,1.5.2Z",
    fill: "#abbfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16918",
    "data-name": "Path 16918",
    d: "M285.3,164.2h-2.8l-2.7-5.3h-2.5v3.7h1.6v1.6h-5v-1.6h1.6v-9.8h-1.6v-1.6h5.7a5.1,5.1,0,0,1,3.5,1,3.5,3.5,0,0,1,1.1,2.7,3.6,3.6,0,0,1-2.7,3.6l2.2,4.1h1.6Zm-3-9.2a2,2,0,0,0-.7-1.7,3.9,3.9,0,0,0-2.3-.5h-2v4.6h2a3.3,3.3,0,0,0,2.3-.6,2.3,2.3,0,0,0,.7-1.8",
    fill: "#abbfc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16919",
    "data-name": "Path 16919",
    d: "M303.2,152.8h-1.7v9.8h1.6v1.6h-4.8v-1.6h1.4v-7.3h-.1l-4.1,8.1h-.9l-4.2-8.2h0v7.4h1.4v1.6h-4.7v-1.6h1.5v-9.8H287v-1.6h3.2l4.9,9.6h.1l4.7-9.6h3.3Z",
    fill: "#abbfc9"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDmfTagLine);
export default __webpack_public_path__ + "static/media/dmf_tagLine.607237f1.svg";
export { ForwardRef as ReactComponent };